import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

export function LineItemsTooLightQuestionBubble() {
  return (
    <Tooltip
      variant="error"
      content={
        <Stack gap={2}>
          <T weight="bold">Too light</T>
          <T size="xs" color="secondary">
            LTL shipments should be a minimum of 60lbs. Each individual item
            must be at least 20lbs. We recommend you use a parcel service for
            this shipment instead
          </T>
        </Stack>
      }
    />
  );
}
